import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

const DEFAULT_ICON_SVG = `<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
<rect width="64" height="64" rx="6" fill="#0a0e14"/>
<circle cx="32" cy="32" r="9" fill="#00ff9c"/>
</svg>`;

function svgToDataUrl(svg, color) {
    const colored = svg.replace(/#00ff9c/g, color || "#00ff9c");
    return "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(colored)));
}

function setFavicon(href) {
    document.querySelectorAll("link[rel='icon'], link[rel='shortcut icon']").forEach((el) => el.remove());
    const link = document.createElement("link");
    link.rel = "icon";
    link.href = href;
    document.head.appendChild(link);
}

/** Global side-effect: sync favicon with effective branding.
 *  - Logged in: uses AuthContext branding (tenant/operator merged)
 *  - Logged out: falls back to /api/settings/public (operator defaults)
 */
export default function FaviconSync() {
    const { branding, user } = useAuth();

    useEffect(() => {
        let cancelled = false;
        async function sync() {
            let logo = null;
            let color = "#00ff9c";
            let brandName = null;

            const eff = branding?.effective;
            if (eff) {
                logo = eff.logo_data_url;
                color = eff.accent_color || color;
                brandName = eff.brand_name;
            } else if (!user) {
                try {
                    const { data } = await api.get("/settings/public");
                    logo = data?.branding?.logo_data_url || null;
                    brandName = data?.branding?.brand_name;
                } catch {}
            }
            if (cancelled) return;
            const href = logo || svgToDataUrl(DEFAULT_ICON_SVG, color);
            setFavicon(href);

            if (brandName && typeof document !== "undefined") {
                const base = document.title.split(" — ")[0] || "PRC CMC";
                document.title = `${base} — ${brandName}`;
            }
        }
        sync();
        return () => { cancelled = true; };
    }, [branding, user]);

    return null;
}
